// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__Cg_OI","author":"Table_author__3ywjH","authorImage":"Table_authorImage__2QQ7P","unreadRow":"Table_unreadRow__35keP"};